import React from "react"
import "./sidebar.scss"

export default function Sidebar({ children }) {
  return <div className={'sidebar'}>
      {children}
      </div>
}